import React from "react";
import { Box, Paper, Typography, List, ListItem, ListItemText } from "@mui/material";

const DeleteAccountGuideline = () => {
  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "40px auto",
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 3,
          backgroundColor: "#ffffff",
        }}
      >
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Delete Account Guidelines
        </Typography>

        <Typography variant="body1" mb={3}>
          If you no longer wish to use the <b>Hermony</b> app, you can permanently delete your
          account at any time. Before proceeding, please read the important notes and follow
          all steps carefully to avoid accidental data loss.
        </Typography>

        {/* Important Notes */}
        <Typography variant="h5" fontWeight={600} mb={2}>
          ⚠ Important Before You Delete
        </Typography>

        <List sx={{ listStyleType: 'disc', pl: 4 }} component="ul">
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Account deletion is permanent and cannot be reversed." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="All your messages, matches, and profile data will be permanently removed." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You will not be able to recover your account after it is deleted." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Any active subscriptions must be canceled through your App Store or Play Store." />
          </ListItem>
        </List>

        {/* Numbered Steps */}
        <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
          ✅ Steps to Delete Your Account
        </Typography>

        <List component="ol" sx={{ listStyleType: 'decimal', pl: 4 }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Open the Hermony app and go to your Account section." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Scroll down until you find the Delete Account option." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Tap on Delete My Account." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="A confirmation popup will appear; select Yes to proceed." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Confirm again to permanently remove your account and all associated data." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Once confirmed, you will be logged out and your account will be deleted." />
          </ListItem>
        </List>

        {/* Additional Info */}
        <Typography variant="h5" fontWeight={600} mt={4} mb={2}>
          ℹ Additional Information
        </Typography>

        <List sx={{ listStyleType: 'disc', pl: 4 }} component="ul">
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You can pause your profile instead of deleting it if you want a break." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="If you face issues deleting your account, contact support through the Help section." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Subscriptions must be canceled separately through your device's app store." />
          </ListItem>

          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Once deleted, your account cannot be restored, but you can create a new one anytime." />
          </ListItem>
        </List>

      </Paper>
    </Box>
  );
};

export default DeleteAccountGuideline;
